import React, { useState, useEffect } from "react";
import "./home.css";
import { useNavigate } from "react-router-dom";
import { useApiServices } from "../../services/endpoints/ApiEndpoint";
import { payloadProductByLocation } from "../../utils/models";
import { getLocalStorage, removeLocalStorage, setLocalStorage, setSessionStorage } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import Image from "../../components/image/Image";
import { updateUser } from "../../redux/actions/userSlice";
import Button from "../../components/button/Button";

const Home: React.FC = () => {
  const { GetProductsByLocationAsync, AuthInfoAsync } = useApiServices()
  const api = useApiServices()
  const locationRedux = useSelector((state: RootState) => state.location)
  const dispatch = useDispatch()
  const user = useSelector((state: RootState) => state.user)
  const [activeSortRows, setActiveSortRows] = useState<boolean>(true);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [products, setProducts] = useState<[]>([])
  const [direction, setDirection] = useState<'left' | 'right'>('right');
  const [location, setLocation] = useState<{ lat: number; lng: number, name?: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [search, setSearch] = useState<string>('')
  const [addressHistory, setAddressHistory] = useState<any[]>([])

  // Helper function to check if two coordinates are close enough (within ~100 meters)
  const areCoordinatesClose = (lat1: number, lng1: number, lat2: number, lng2: number, threshold = 0.001) => {
    const latDiff = Math.abs(lat1 - lat2);
    const lngDiff = Math.abs(lng1 - lng2);
    return latDiff < threshold && lngDiff < threshold;
  };

  const onLogout = (): void => {
    removeLocalStorage("accessToken");
    removeLocalStorage("refreshToken");
    removeLocalStorage("expireTime");
    removeLocalStorage("userId");
    navigate("/login");
  };
  const fetchData = (lat: number, lng: number) => {
    // Check if location matches any address in history
    const matchingAddress = addressHistory.find((addr: any) =>
      areCoordinatesClose(lat, lng, addr.latitude, addr.longitude)
    );

    if (matchingAddress) {
      // Use name from address history
      setLocation({
        lat: lat,
        lng: lng,
        name: matchingAddress.addressLine1
      })
      getProduct(lat, lng)
    } else {
      // Fetch name from OSM
      getLocationNameOSM(lat, lng)
        .then(name => {
          setLocation({
            lat: lat,
            lng: lng,
            name: name
          })
        })
        .catch(err => {
          setLocation({
            lat: lat,
            lng: lng
          })
        });
      getProduct(lat, lng)
    }
  }
  useEffect(() => {
    const delay = setTimeout(() => {
      getProduct(null, null, search)
    }, 1000)
    return () => clearTimeout(delay)
  }, [search])
  useEffect(() => {
    console.log('locationRedux', locationRedux);

    if (location?.lat != locationRedux.lat || location?.lng != locationRedux.lng) {
      setLocation({
        lat: locationRedux.lat,
        lng: locationRedux.lng
      })
      console.log('call here redux change!!');
      
      fetchData(locationRedux.lat, locationRedux.lng)
    }
  }, [locationRedux])

  useEffect(() => {
    AuthInfoAsync().then(res => {
      if (res.isSuccess) {
        dispatch(updateUser(res.result))
      }
    }).catch(error => {
      onLogout()
    })

    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser.');
      return;
    }

    if (locationRedux.isDefault) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('location', position.coords);
          console.log('call here redux isDefault!!');
          fetchData(position.coords.latitude, position.coords.longitude)
        },
        (err) => {
          setError(`Error: ${err.message}`);
          console.log('error', err);
        }
      );
    }

  }, []);

  // Fetch address history
  useEffect(() => {
    const fetchAddressHistory = async () => {
      if (!user?.entityUniqueIdentifierId) return

      try {
        const { isSuccess, result } = await api.GetAddressesAsync(user.entityUniqueIdentifierId)
        if (isSuccess && Array.isArray(result)) {
          setAddressHistory(result)
        }
      } catch (error) {
        console.error('Error fetching address history:', error)
      }
    }

    fetchAddressHistory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.entityUniqueIdentifierId]);

  // Update location name if it matches address history
  useEffect(() => {
    if (location && addressHistory.length > 0) {
      const matchingAddress = addressHistory.find((addr: any) =>
        areCoordinatesClose(location.lat, location.lng, addr.latitude, addr.longitude)
      );

      if (matchingAddress && location.name !== matchingAddress.addressLine1) {
        setLocation(prev => prev ? {
          ...prev,
          name: matchingAddress.addressLine1
        } : null)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressHistory]);

  const navigate = useNavigate();
  const getProduct = async (lat?: number | null, lng?: number | null, text?: string) => {
    let payload: payloadProductByLocation = {
      latitude: lat ?? locationRedux.lat,
      longitude: lng ?? locationRedux.lng,
      searchText: text ?? '',
      categoryIds: [],
      storeIds: []
    }
    const { result } = await GetProductsByLocationAsync(payload)
    if (result) {
      let maped = result.map((product: any) => {
        const prices = product.stores.map((store: any) => store.price);
        const lowest = Math.min(...prices);
        const highest = Math.max(...prices);

        return {
          productId: product.productId,
          productName: product.productName,
          lowestPrice: lowest,
          highestPrice: highest,
          stores: product.stores,
          productGroupName: product.productGroupName,
          productGroupId: product.productGroupId,
          unit: product.unit || "หน่วย",
          products: product.products || []
        };
      })
      console.log('maped', maped);

      setProducts(maped)
      setSessionStorage('pricing', maped)
    }
    console.log('result', result);

  }

  async function getLocationNameOSM(lat: number, lng: number): Promise<string> {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;

    const response = await fetch(url, {
      headers: {
        'User-Agent': 'Concrete-delivery-dev'
      }
    });
    const data = await response.json();

    return data.display_name || 'No address found';
  }

  const imagesBanner = [
    "/assets/images/test-banner-home-01.png",
    "/assets/images/test-banner-home-02.png",
    "/assets/images/test-banner-home-03.png",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection('right');
      setCurrentIndex((prevIndex) => (prevIndex + 1) % imagesBanner.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [imagesBanner.length]);

  const handleSlide = (index: number) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    console.log('user', user);

  }, [user])


  return (
    <section className="block-home-wrapper lg:container lg:mx-auto">
      <div className="block-name-user-location">
        <p className="name-user">
          สวัสดี &nbsp;
          <span>{user.firstName}</span>
        </p>
        <div className="location">
          <button
            className="btn btn-location"
            onClick={() => {
              // const modal = document.getElementById("my_modal_1");
              // if (modal instanceof HTMLDialogElement) {
              //   modal.show();
              // }
              navigate('location')
            }}
          >
            <img
              src={"/assets/icons/icon-location-blue.svg"}
              alt="icon-location"
              className="icon icon-location"
            />
            เลือกตำแหน่ง
          </button>
          <dialog id="my_modal_1" className="modal home-page">
            <div className="modal-box">
              <form method="dialog">
                {/* if there is a button in form, it will close the modal */}
                <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
                  ✕
                </button>
              </form>
              <h3 className="font-bold text-lg">Hello!</h3>
              <p className="py-4">
                Press ESC key or click on ✕ button to close
              </p>
            </div>
          </dialog>
        </div>
      </div>
      <div className="block-search-location">
        <label className="input input-bordered">
          <input
            type="text"
            className="grow"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="w-4 h-4 opacity-70"
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
        </label>
      </div>
      <div className="block-location-detail">
        <img
          src={"/assets/icons/icon-pin-line-orange.svg"}
          alt="icon-pin-line-orange"
          className="icon icon-pin-line-orange"
        />
        <div className="location-detail">
          <p className="title">จัดส่งที่</p>
          <p className="detail" onClick={()=>navigate('location')}>{location?.name || 'ไม่ทราบชื่อ'}</p>
        </div>
      </div>
      <div className="block-home-banner">
        <div className="home-banner-slider">
          <div
            className="banner-slider-item"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
              flexDirection: direction === 'right' ? 'row' : 'row-reverse',
            }}
          >
            {imagesBanner.map((src, index) => (
              <img src={src} className="item-image" alt={`carousel-item-${index + 1}`} />

            ))}
          </div>
          <div className="btn-banner-slider">
            {imagesBanner.map((_, index) => (
              <button
                key={index}
                className={`btn ${currentIndex === index ? 'btn-active' : ''}`}
                onClick={() => handleSlide(index)}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="block-product-type">
        <button className="btn btn-ghost btn-type btn-type-iron">
          <div className="image-type">
            <img
              src={"/assets/icons/icon-type-iron.svg"}
              alt="icon-type-iron"
              className="icon icon-type-iron"
            />
          </div>
          <p className="type-name">เหล็ก</p>
        </button>

        <button className="btn btn-ghost btn-type btn-type-brick">
          <div className="image-type">
            <img
              src={"/assets/icons/icon-type-brick.svg"}
              alt="icon-type-brick"
              className="icon icon-type-brick"
            />
          </div>
          <p className="type-name">อิฐ</p>
        </button>

        <button className="btn btn-ghost btn-type btn-type-rock">
          <div className="image-type">
            <img
              src={"/assets/icons/icon-type-rock.svg"}
              alt="icon-type-rock"
              className="icon icon-type-rock"
            />
          </div>
          <p className="type-name">หิน</p>
        </button>

        <button className="btn btn-ghost btn-type btn-type-mortar">
          <div className="image-type">
            <img
              src={"/assets/icons/icon-type-mortar.svg"}
              alt="icon-type-mortar"
              className="icon icon-type-mortar"
            />
          </div>
          <p className="type-name">ปูน</p>
        </button>

        <button className="btn btn-ghost btn-type btn-type-sand">
          <div className="image-type">
            <img
              src={"/assets/icons/icon-type-sand.svg"}
              alt="icon-type-sand"
              className="icon icon-type-sand"
            />
          </div>
          <p className="type-name">ทราย</p>
        </button>
      </div>

      <div className="block-product-list">
        <div className="product-list-title-sort">
          <p className="product-list-title">รายการสินค้า</p>
          <div className="product-list-sort">
            <div className="sort-column btn-sort">
              <button
                className="btn btn-ghost"
                onClick={() => setActiveSortRows(false)}
              >
                <img
                  src={`/assets/icons/sort-column-${activeSortRows ? "black" : "orange"
                    }.svg`}
                  alt="sort-column-black"
                  className="icon sort-column-black"
                />
              </button>
            </div>
            <hr className="line" />
            <div className="sort-rows btn-sort">
              <button
                className="btn btn-ghost"
                onClick={() => setActiveSortRows(true)}
              >
                <img
                  src={`/assets/icons/sort-rows-${activeSortRows ? "orange" : "black"
                    }.svg`}
                  alt="icon-type-sand"
                  className="icon icon-type-sand"
                />
              </button>
            </div>
          </div>
        </div>
        <div
          className={`product-list ${activeSortRows ? "rows" : "column"} ${products?.length === 0 ? "!block" : ""
            }`}
        >
          {products?.length !== 0 ? (
            products?.map((p: any, i: number) => (
              <div key={i} className="card card-product-home-page">
                <figure className="block-image-product">
                  {/* <img
                    src="/assets/images/no-image-product.png"
                    alt="no-img-product"
                    className="rounded-xl w-full shadow-[0_2.7px_32.4px_0px_#0000001A]"
                  /> */}
                  <Image id={p.productId} alt="no-img-product" className="rounded-xl w-full shadow-[0_2.7px_32.4px_0px_#0000001A]" />
                </figure>
                <div className="card-body min-w-0">
                  <h1 className="card-title truncate">
                    {p.productGroupName || p.productName}
                  </h1>
                  <h1 className="unit-price">{p.lowestPrice?.toLocaleString()}{p.lowestPrice != p.highestPrice ? ` - ${p.highestPrice?.toLocaleString()}` : ''} /{p.unit}</h1>
                  <div className="card-actions mt-3">
                    <Button
                      variant="outline"
                      size="sm"
                      fullWidth
                      onClick={() => { user != null ? navigate(`/product/${p.productId}${p.productGroupId ? `/${p.productGroupId}` : ''}`) : onLogout() }}
                      className="btn-product-detail"
                    >
                      {user != null ? 'รายละเอียด' : 'เข้าสู่ระบบ'}
                    </Button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-product">ไม่พบสินค้า</div>
          )}
        </div>
      </div>
      {/* <div className="block-pagination join">
        <button className="join-item btn btn-pagination-prev">
          <img
            src="/assets/icons/icon-prev-orange.svg"
            className="icon-prev-orange"
            alt="icon-prev-orange"
          />
        </button>
        <input
          className="join-item btn btn-pagination-numner btn-square"
          type="radio"
          name="options"
          aria-label="1"
          defaultChecked
        />
        <input
          className="join-item btn btn-pagination-numner btn-square"
          type="radio"
          name="options"
          aria-label="2"
          disabled
        />
        <input
          className="join-item btn btn-pagination-numner btn-square"
          type="radio"
          name="options"
          aria-label="3"
          disabled
        />
        <input
          className="join-item btn btn-pagination-numner btn-square max-[430px]:hidden"
          type="radio"
          name="options"
          aria-label="4"
          disabled
        />
        <input
          className="join-item btn btn-pagination-numner btn-square max-[430px]:hidden"
          type="radio"
          name="options"
          aria-label="5"
        />
        <input
          className="join-item btn btn-pagination-numner btn-square max-[430px]:hidden"
          type="radio"
          name="options"
          aria-label="6"
        />ห
        <button className="join-item btn btn-pagination-next">
          <img
            src="/assets/icons/icon-next-orange.svg"
            className="icon-next-orange"
            alt="icon-next-orange"
          />
        </button>
      </div> */}
    </section>
  );
};

export default Home;
